import { LoadableApp } from 'ui-seeker/core'
import { TTOO_DESTINATION, TTOO_COMPETENCE, TTOO_RAW, TTOO_ADMIN} from 'app/config'

const Destination = LoadableApp(import('./Destination'))
const Competence = LoadableApp(import('./Competence'))
const Raw = LoadableApp(import('./Raw'))
const Admin = LoadableApp(import('./Admin'))

const PageRoutes = [
    { path: TTOO_DESTINATION.path, component: Destination, needLogin: true },
    { path: TTOO_COMPETENCE.path, component: Competence, needLogin: true },
    { path: TTOO_RAW.path, component: Raw, needLogin: true },
    { path: TTOO_ADMIN.path, component: Admin, needLogin: true }
]

export default PageRoutes